// 标杆客户静态数据（首页 productionShow 使用）

// 海外客户（带 logo 图片）
export const customerLogos = [
	{ path: require('../assets/img/index/customers/1.png'), desc: '韩国三星集团' },
	{ path: require('../assets/img/index/customers/2.png'), desc: '首尔大学医院' },
	{ path: require('../assets/img/index/customers/3.png'), desc: '韩国希杰集团' },
	{ path: require('../assets/img/index/customers/4.png'), desc: '日本国立循环器病研究中心' },
	{ path: require('../assets/img/index/customers/5.png'), desc: '哈佛大学' },
	{ path: require('../assets/img/index/customers/6.png'), desc: '麻省理工学院' },
	{ path: require('../assets/img/index/customers/7.png'), desc: '帝国理工学院' },
	{ path: require('../assets/img/index/customers/8.png'), desc: '伦敦大学' },
	{ path: require('../assets/img/index/customers/9.png'), desc: '日本京都大学' },
	{ path: require('../assets/img/index/customers/10.png'), desc: '大阪大学' },
	{ path: require('../assets/img/index/customers/11.png'), desc: '首尔大学' },
	{ path: require('../assets/img/index/customers/12.png'), desc: '马来西亚国立大学' }
]

// 国内客户（纯文字）
export const customerNames = [
	{ name: '中国医科大学' },
	{ name: '广东医科大学' },
	{ name: '大连理工大学' },
	{ name: '上海中医药大学' },
	{ name: '广州市儿童医院' },
	{ name: '四川大学华西医院' },
	{ name: '重庆第四人民医院' },
	{ name: '中国医学科学院\n医药生物技术研究所' },
	{ name: '中国医学科学院\n药用植物研究所' },
	{ name: '中国石化\n大连石油化工研究所' },
	{ name: '中国科学院\n沈阳应用生态研究所' },
	{ name: '湖南中信\n湘雅遗传及生殖医院' }
]
